import Config from '~/config';

const ChinaWrap = ({ chinaOnly = null, nonChina = null }) => {
  const isChina = Config.isChina();
  if (isChina) return chinaOnly;
  return nonChina;
};

export default ChinaWrap;
